import { useMutation } from 'react-query';

import { FreezeRateResponse, freezeRate } from '@utils/backend-api/freezeRate';

export default function useFreezeRate() {
  const { mutate, isLoading, isError } = useMutation(() => freezeRate(), {
    onSuccess: (data: FreezeRateResponse) => {
      if (data.redirectUri) {
        window.location.href = data.redirectUri;
      }
    },
    onError: (data: FreezeRateResponse) => {
      window.location.href = data.redirectUri;
    },
  });
  return { mutate, isLoading, isError };
}
